import React from "react";
import {
  Box,
  Typography,
  Button,
  Card,
  CardContent,
  Slide,
  Backdrop,
  IconButton,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import BalanceCard from "./BalanceCard.jsx";
import { Padding } from "@mui/icons-material";
import Explore from '../../../assets/explore.png'
import Ribbon from '../../../assets/ribbon.png'
import BalanceInfoBanner from "./BalanceInfoBanner";
import BottomOrderBar from "./PlaceOrderFab";
import WaitingLoder from "../../../WaitingLoader/component";
import tagcoin from '../../../assets/tagCoins.png'
import { useLocation, useNavigate } from "react-router-dom";
const BalanceBottomSheet = ({ open,setOrderNowFlag,loader, onClose,vmInventory,onIncrement,onDecrement,preCart ,paymentOption,CreateOrderApi}) => {
const BASE_URL = "https://daalchini.s3.ap-south-1.amazonaws.com/dcprod/"; // 👈 update this if your actual base path differs
const navigate=useNavigate()
//console.log("preCart",preCart)
  const location = useLocation()
  const params = new URLSearchParams(location.search);
  const value = params.get("value");

const goDpRecharge=()=>{
 navigate(`/dphistory?route=tagOrderId&value=${value}`);

}

  return (
    <>
    {loader&&<WaitingLoder/>}
      {/* Dim background */}
      <Backdrop open={open} sx={{ zIndex: 1200, backdropFilter: "blur(2px)" }} />

      <Slide direction="up" in={open} mountOnEnter unmountOnExit>
        <Box
          sx={{
            position: "fixed",
            bottom: 0,
            left: 0,
            width: "100%",
            bgcolor: "#fff",
            borderTopLeftRadius: 20,
            borderTopRightRadius: 20,
            boxShadow: "0 -4px 20px rgba(0,0,0,0.2)",
            zIndex: 1300,
          }}
        >
          {/* Close Button */}
          <IconButton
            onClick={(e)=>{setOrderNowFlag(false)}}
            sx={{
              position: "absolute",
              top:preCart[0]&&preCart?-50:-60,
              left: "50%",
              transform: "translateX(-50%)",
              backgroundColor: "#fff",
              border: "2px solid #eee",
              zIndex: 10,
            }}
          >
            <CloseIcon />
          </IconButton>

          {/* Balance Header */}
     <Box
            sx={{
              bgcolor: "#FBE240",
              borderTopLeftRadius: 20,
              borderTopRightRadius: 20,
              px: 2,
              py: 3,
              textAlign: "center",
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              position: "relative",
              height:"100px",
            }}
          >
       <BalanceCard paymentOption={paymentOption} />
          </Box> 
          
{ <BalanceInfoBanner  vmInventory={vmInventory} /> }
          {/* Product Section */}
          {vmInventory&&vmInventory[0]?
          <div>
          <Box sx={{ p: 2 }}>
          <Box
    sx={{
         paddingTop:"52px",
      display: "block",
      alignItems: "center",
      mb: 1.5,
      gap: 1,
    }}
  >
    {/* Left Image */}
    <div style={{display:"flex"}}>
    <Box
      component="img"
      src={Explore}
      alt="Explore Icon"
      sx={{
        width: 24,
        height: 24,
        objectFit: "contain",
       
      }}
    />
    <Typography
      variant="subtitle1"
      fontWeight={600}
      sx={{
        color: "#000",
        fontSize: "1rem",ml:"5px"
      }}

    >
      Explore Our Best Options
    </Typography>
</div>

    {/* Text */}
   



            {/* Product Cards */}
            <Box sx={{ display: "flex", gap: 1.5, overflowX: "auto" , padding: "5px"}}>
              {vmInventory?.map((item, i) => (

                <Card
                  key={i}
                  sx={{
                    minWidth: 120,
                    borderRadius: 3,
                    textAlign: "center",
                    flexShrink: 0,
                    boxShadow: "0px 2px 6px rgba(0,0,0,0.1)",
                       
                  }}
                >
                    {console.log("item",item)}
                  <CardContent sx={{}}>
                    <Box
                      component="img"
                    src={
  item.image?.startsWith("http")
    ? item.image
    : `${BASE_URL}${item.image_path}`
}
                      alt={item.name}
                      sx={{
                        width: 70,
                        height: 70,
                        objectFit: "contain",
                       
                        mx: "auto",
                      }}
                    />
            
                    <Box sx={{display:"flex",paddingTop:"22px",marginBottom:"-9px"}}>
    <Box
      sx={{
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",
        backgroundImage: `url(${Ribbon})`, // 🔁 Replace path
        backgroundRepeat: "no-repeat",
        backgroundSize: "100% 100%",
        width: 120, // adjust width as per image
        height: 30, // adjust height as per image
        px: 2,
        py: 1,
        color: "#007A3D",
        fontWeight: 700,
        userSelect: "none",
        
      }}
    >
      <Typography variant="body1" sx={{ fontWeight: 700, color: "#007A3D" }}>
        ₹ {Number(item.offer_price).toFixed(2)}

      </Typography>
    </Box>
    </Box>


                    {item.mycount==0?
                    <Button
                      variant="outlined"
                      size="small"
                      style={{ backgroundColor:"white"}}
                      sx={{
                        mt: "W15px",
                        textTransform: "none",
                        borderRadius: 2,
                        fontSize: "0.75rem",
                        borderColor: "#0C9B37",
                        background:"white",
                        color: "#0C9B37",
                            position: "relative",top: "-65px",
                           
    left: "25px",
                        //"&:hover": { borderColor: "#0b8c32", color: "#0b8c32" },
                      }}
                     onClick={(e)=>{onIncrement(e,i,item.slot_id,0,"add")}}
                    >
                      Add
                    </Button>:
                    <Button
                      variant="outlined"
                      size="small"
                      sx={{
                        mt: "W15px",
                        textTransform: "none",
                        borderRadius: 2,
                        fontSize: "0.75rem",
                        borderColor: "#0C9B37",
                        background:"#0C9B37",
                        color: "#ffffffff",
                            display: "flex",
                                marginLeft: "30px",
    justifyContent:"space-around",
                            position: "relative",top: "-65px",
    left: "25px",
     "&:hover": { borderColor: "#0b8c32",   background:"#0C9B37", color: "#ffffffff" },
                       
                      }}
                    >
                      <span  onClick={(e) => onDecrement(e, i, item.slot_id, item.mycount)}>-</span><span>{item.mycount}</span><span onClick={(e)=>{onIncrement(e,i,item.slot_id,item.mycount,"add")}}>+</span>
                    </Button>}

                        <Typography
  variant="body2"
  fontWeight={600}
  noWrap
  sx={{
    display: "block",
    maxWidth: 120, // 👈 Adjust width as per your layout
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
    color:"#583C43B2"
       
  }}
>
  {item.mv_name}
</Typography>
                  </CardContent>
                </Card>
              ))}
            </Box>
            </Box>
          </Box></div>:<><div style={{display:"flex",    justifyContent: "center",marginTop: "50px"}}><img src={tagcoin} style={{width:"73px"}}/></div>
          
          <Typography textAlign={"center"} style={{fontWeight:600}}>
            Add more Daalchini Balance<br/>
& <br/>
Shop without interruptions!
          </Typography>


<Box padding={"15px"}>

              <Button
              onClick={()=>{goDpRecharge()}}
      variant="contained"
      fullWidth
      sx={{
        backgroundColor: "#0A9F61",     // green color similar to your image
        color: "#fff",
        borderRadius: "10px",           // large rounded corners
        fontSize: "20px",
        fontWeight: 400,
        paddingY: "14px",
        textTransform: "none",
        "&:hover": {
          backgroundColor: "#0A8A54",   // hover shade
        },
      }}
    >
      Add Daalchini Points
    </Button>
    </Box>
          
          </>
          
          }

  {preCart[0]&&preCart&&<BottomOrderBar preCart={preCart} CreateOrderApi={CreateOrderApi} paymentOption={paymentOption}/>}
        </Box>
      </Slide>
    </>
  );
};

export default BalanceBottomSheet;
